import React from 'react'
import { Button } from '@/components/ui/button'
import { showNotification } from '@/services/notificationService'
import { AppDispatch, RootState } from '@/redux'
import { createPortalSession } from '@/services/billingService'
import { useDispatch, useSelector } from 'react-redux'
import { ExternalLink } from 'lucide-react'

interface BillingPortalButtonProps {
  token: string
  organizationId: string
}

export const BillingPortalButton: React.FC<BillingPortalButtonProps> = ({
  token,
  organizationId
}) => {
  const { loading } = useSelector((state: RootState) => state.app)
  const dispatch: AppDispatch = useDispatch()

  const handleOpenPortal = async () => {
    try {
      const resp = await dispatch(createPortalSession(token, organizationId))
      if (resp.data?.url) {
        window.location.href = resp.data.url
      } else {
        showNotification({ data: undefined, err: resp.err }, '', {})
      }
    } catch (error) {
      console.error('Error creating portal session:', error)
      showNotification({ data: undefined, err: 'Failed to open billing portal' }, '', {})
    }
  }

  return (
    <div className="px-6 py-4 flex items-center justify-between gap-4">
      <div>
        <p className="text-sm font-medium text-gray-900">Payment &amp; Billing</p>
        <p className="text-xs text-gray-500 mt-0.5">Manage payment method, billing address, and cancel subscription</p>
      </div>
      <Button
        onClick={handleOpenPortal}
        disabled={loading}
        variant="outline"
        size="sm"
        className="shrink-0"
      >
        {loading ? (
          <span className="flex items-center gap-2">
            <span className="h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
            Opening…
          </span>
        ) : (
          <>
            <ExternalLink className="mr-2 h-3.5 w-3.5" />
            Manage
          </>
        )}
      </Button>
    </div>
  )
}
